import { Content } from 'shared/components/Content';
import { AnswersOnQuestionsContainer } from '../AnswersOnQuestionsContainer';
import { DiscountConditionsContainer } from '../DiscountConditionsContainer';
import { VideoBlockContainer } from '../VideoBlockContainer';
import { useDeviceType } from '@cian/ui-kit';
import { ButtonLinkContainer } from '../ButtonLinkContainer';
import { HowGetDealContainer } from '../HowGetDealContainer';
import { HowConnectDiscountItemContainer } from '../HowConnectDiscountItemContainer';
import { NeedConsultationContainer } from '../NeedConsultationContainer';
import { CalculatorContainer } from '../CalculatorContainer';

export const ContentContainer: React.FC = () => {
  const device = useDeviceType();

  return (
    <Content
      answersOnQuestions={<AnswersOnQuestionsContainer />}
      discountConditions={<DiscountConditionsContainer />}
      calculator={<CalculatorContainer />}
      videoBlock={<VideoBlockContainer />}
      howGetDeal={<HowGetDealContainer />}
      needConsultation={<NeedConsultationContainer />}
      ButtonLink={ButtonLinkContainer}
      HowConnectDiscountItem={HowConnectDiscountItemContainer}
      device={device}
    />
  );
};
